import { s as surfaceDarkStyles } from '../component/surfaceDark-CjzXgz54.js';
import { s as surfaceDarkInfoStyles } from '../component/surfaceDarkInfo-nak4bJe3.js';
import { s as surfaceLightStyles } from '../component/surfaceLight-DGLrbQeB.js';
import { d as deepMerge } from '../../LocalModules/storm-ui-utils/dist/esm/deepMerge-DmW5IEKC-DLFdHXY0.js';

const getSurfaceStylesBySurfaceType = (theme, surfaceType) => {
  if (surfaceType === 'dark') return theme.surfaceDark || surfaceDarkStyles;
  if (surfaceType === 'blue') return theme.surfaceDarkInfo || surfaceDarkInfoStyles;
  return theme.surfaceLight || surfaceLightStyles;
};
function surfaceModifier(theme, surfaceType) {
  const surfaceThemeOverrides = getSurfaceStylesBySurfaceType(theme, surfaceType);
  const modifiedTheme = {
    ...theme
  };

  // For any theme targets with overrides, merge the current theme values
  // with any of the overridden values. Making multiple deepMerge calls is
  // arguably better here because of the small number of overridden targets for now.
  Object.entries(surfaceThemeOverrides).forEach(([key, value]) => {
    modifiedTheme[key] = deepMerge({}, theme[key], value);
  });
  return modifiedTheme;
}

export { surfaceModifier as s };
//# sourceMappingURL=surface-CYA_IjK1.js.map
